import { create } from 'zustand'
import { persist } from 'zustand/middleware'

interface ListingsStore {
  lastListingsUrl: string
  setLastListingsUrl: (url: string) => void
}

export const useListingsStore = create<ListingsStore>()(
  persist(
    (set) => ({
      lastListingsUrl: '/listings',
      setLastListingsUrl: (url) => set({ lastListingsUrl: url }),
    }),
    {
      name: 'listings-storage',
    }
  )
)
